export const BASE_URL = "https://fso-test-cms.amplitudo.me";
export const API_URL = BASE_URL + "/api/";
